
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/psicologo",
      function () {
        return require("private-next-pages/psicologo/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/psicologo"])
      });
    }
  